export default __webpack_public_path__ + "static/media/search.c3cc07c5.svg";